import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { LandRegistryService } from '../_services';
import * as LandRegistryActions from '../_actions/landRegistry';

@Injectable({
  providedIn: 'root',
})
export class LandRegistryEffects {
  landRegistry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandRegistryActions.loadLandRegistries),
      mergeMap(() =>
        this.landRegistryService.getLandRegistries().pipe(
          map((landRegistries) =>
            LandRegistryActions.loadLandRegistriesSuccess({ landRegistries })
          ),
          catchError((error) => of(LandRegistryActions.loadLandRegistriesFailure({ error })))
        )
      )
    )
  );

  addLandRegistry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandRegistryActions.addLandRegistry),
      mergeMap(({ landRegistry }) =>
        this.landRegistryService.saveLandRegistry(landRegistry).pipe(
          map((savedLandRegistry) =>
            LandRegistryActions.addLandRegistrySuccess({ landRegistry: savedLandRegistry })
          ),
          catchError((error) => of(LandRegistryActions.addLandRegistryFailure({ error })))
        )
      )
    )
  );

  updateLandRegistry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandRegistryActions.updateLandRegistry),
      mergeMap(({ landRegistry }) =>
        this.landRegistryService.saveLandRegistry(landRegistry).pipe(
          map((updatedLandRegistry) =>
            LandRegistryActions.updateLandRegistrySuccess({ landRegistry: updatedLandRegistry })
          ),
          catchError((error) => of(LandRegistryActions.updateLandRegistryFailure({ error })))
        )
      )
    )
  );

  deleteLandRegistry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandRegistryActions.deleteLandRegistry),
      mergeMap(({ id }) =>
        this.landRegistryService.deleteLandRegistry(id).pipe(
          map(() => LandRegistryActions.deleteLandRegistrySuccess({ id })),
          catchError((error) => of(LandRegistryActions.deleteLandRegistryFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private landRegistryService: LandRegistryService
  ) {}
}
